import {MapRegion, RegionConfig} from '../../../types'

import {AMWA_CONFIG} from './amwa.config'
import {APAC_CONFIG} from './apac.config'

export const REGION_CONFIGS: Partial<Record<MapRegion, RegionConfig>> = {
  a_AMWA: AMWA_CONFIG,
  a_APAC: APAC_CONFIG
}

export const isRegionConfigured = (region: string): region is MapRegion => {
  return region in REGION_CONFIGS
}

export const getRegionConfig = (region: MapRegion): RegionConfig | undefined => {
  return REGION_CONFIGS[region]
}
